module.exports = __webpack_public_path__ + "img/discussion.b2d2d6de.jpg";